import { render, staticRenderFns } from "./onboarding-slide-notes.vue?vue&type=template&id=f1316f12&scoped=true&"
import script from "./onboarding-slide-notes.vue?vue&type=script&lang=js&"
export * from "./onboarding-slide-notes.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-slide-notes.vue?vue&type=style&index=0&id=f1316f12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1316f12",
  null
  
)

/* custom blocks */
import block0 from "./onboarding-slide-notes.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports